import { DatePart } from '../../infrastructure/date-part';
import { EventRelationship } from './event-relationship';
import { Sport } from './sport';
import { EventVisibility } from './event-visibility';

export { EventRelationship } from './event-relationship';
export { EventVisibility } from './event-visibility';

export class EventEntity {

    public static fromDto(dto: any): EventEntity {
        if (!dto) {
            return new EventEntity();
        }
        const entity = new EventEntity();

        entity.id = dto.id;
        entity.code = dto.code;
        entity.userId = dto.userId;
        entity.language = dto.language;
        entity.organizer = dto.organizer;
        entity.title = dto.title;
        entity.location = dto.location;
        entity.latitude = dto.latitude ?? null;
        entity.longitude = dto.longitude ?? null;
        entity.description = dto.description;
        entity.startDate = new DatePart(dto.startDate);
        entity.endDate = new DatePart(dto.endDate);
        entity.registrationEnabled = dto.registrationEnable ?? false;
        entity.registrationExpirationDate = dto.registrationExpirationDate ? new DatePart(dto.registrationExpirationDate) : null;
        entity.visibility = dto.visibility;
        entity.sport = dto.sport;
        entity.sportOther = dto.sportOther ?? '';
        entity.concurrency = dto.concurrency;
        entity.relationship = dto.relationship ?? EventRelationship.Owner;
        entity.isAccepted = dto.isAccepted ?? true;
        entity.associationId = dto.associationId ?? null;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): EventEntity[] {
        const entities: EventEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = EventEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: EventEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }
    public id: string = null;
    public code: string = null;
    public userId: string = null;
    public language: string = null;
    public title: string = '';
    public organizer: string = '';
    public description: string = '';
    public location: string = '';
    public latitude: number | null = null;
    public longitude: number | null = null;
    public startDate: DatePart = new DatePart();
    public endDate: DatePart = new DatePart();
    public registrationEnabled: boolean = false;
    public registrationExpirationDate: DatePart | null = null;
    public visibility: EventVisibility = EventVisibility.Public;
    public sport: Sport = Sport.NotSet;
    public sportOther: string = '';
    public concurrency: string = null;
    public relationship: EventRelationship = EventRelationship.Owner;
    public isAccepted: boolean = true;
    public associationId: string | null = null;

    public get isShared(): boolean {
        return this.relationship === EventRelationship.Shared;
    }

    public get isParticipant(): boolean {
        return this.relationship === EventRelationship.Participant;
    }

    public applyLocalhostDefaults(): void {
        if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
            return;
        }
        this.title = 'Välkommen till Cup';
        this.organizer = 'Föreningen IK';
        this.description = 'Beskrivningen';
        this.location = 'Orten';
    }

    public toDto(): any {
        return {
            id: this.id,
            code: this.code,
            userId: this.userId,
            language: this.language,
            title: this.title,
            organizer: this.organizer,
            description: this.description,
            location: this.location,
            latitude: this.latitude,
            longitude: this.longitude,
            startDate: this.startDate.toISOString(),
            endDate: this.endDate.toISOString(),
            registrationEnable: this.registrationEnabled,
            registrationExpirationDate: this.registrationExpirationDate?.toISOString() ?? null,
            visibility: this.visibility,
            sport: this.sport,
            sportOther: this.sportOther,
            concurrency: this.concurrency
        };
    }
}
